module.exports = __webpack_public_path__ + "static/media/kid.34c19440.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/kid.jpg
// module id = 543
// module chunks = 0